import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-court-form',
  templateUrl: './court-form.component.html',
  styleUrls: ['./court-form.component.css']
})
export class CourtFormComponent implements OnInit {

  title="Add Court";
  data : any = {};
  formInvalid : boolean = false;
  c : any = {};
  Court_Id : number;
  mode : string;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }

  ngOnInit() { 
    this.route.params.subscribe(params => {      
    this.Court_Id = params['Court_Id'];  
    this.mode  =   params['mode'];
    
    if(this.Court_Id > 0){
      this.GetCourtById(this.Court_Id)
    }    
});

if(this.mode=='view'){
  this.title = "View Court Proceedings";
}
else if(this.mode=='edit'){
  this.title = "Edit Court Proceedings";
}  
}

  SaveCourt(Court: NgForm){    
       if(Court.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }  
   

    else{   
                        
            this.data = this.userService.PostCourt(Court.value);    
            this.data.subscribe(
            (response) => {
              Court.reset();
              Court.resetForm();
              Court.form.markAsPristine();
              Court.form.markAsUntouched();        
              swal('Success!', 'Court Added Successfully .', 'success');
              this.router.navigate(['/home/court']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }
  GetCourtById(Court_Id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdCourt(Court_Id);
        this.data.subscribe(
          (response: any) => {
            this.c = response;        
            
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdateCourt(Court: NgForm) { 
       
    this.data = this.userService.UpdateCourt(Court.value,this.Court_Id);
   this.data.subscribe(
     (response) => {
      Court.reset();
      Court.resetForm();
      Court.form.markAsPristine();
      Court.form.markAsUntouched();           
                   
       swal('Success!', 'Court updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/court']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
  //this.router.navigate(['/home/district']) ; 
  this.c.Court_Code='';
  this.c.Court_Name='';
}




  

}



// WEBPACK FOOTER //
// ./src/app/master/court/court-form/court-form.component.ts